jQuery(document).ready(function ($) {
    // Relies on the $.fn.isPaused/play/pause helpers defined in video-hero.js

    $('.holding-page').each(function () {
        const hero = $(this);

        const video = hero.find('.holding-page__video video');

        const controls = hero.find('.holding-page__controls');
        const toggle = controls.find('.holding-page__controls--toggle');
        const progress = controls.find('.holding-page__controls--progress');
        const elapsed = progress.find('span');

        let interval = 0;

        function togglePlayback() {
            if (video.isPaused()) {
                toggle.addClass('play');
                video.play();
            }
            else {
                toggle.removeClass('play');
                video.pause();
            }
        }

        toggle.on('click', togglePlayback);

        function initProgressBar() {
            clearInterval(interval);

            interval = setInterval(function () {
                const current_time = this.currentTime / this.duration;
                elapsed.css('width', (current_time * 100) + '%');
            }.bind(video.get(0)), 0.5);
        }

        video.on('play', initProgressBar);

        let was_paused = false;

        function percentageFromEvent(event) {
            const offset = progress.offset();
            const width = progress.width();
            const pageX = event.type.indexOf('touch') === 0 ? event.originalEvent.touches[0].pageX : event.pageX;

            return Math.min(100, Math.max(0, ((pageX - offset.left) / width) * 100));
        }

        function scrubTo(event) {
            const percentage = percentageFromEvent(event);

            elapsed.css('width', percentage + '%');

            video.get(0).currentTime = (percentage / 100) * video.get(0).duration;
        }

        function startScrub(event) {
            event.preventDefault();

            was_paused = video.isPaused();

            if (!was_paused) {
                video.pause();
            }

            toggle.removeClass('play');

            scrubTo(event);

            $(document).on('mousemove.scrub touchmove.scrub', scrubTo);
            $(document).on('mouseup.scrub touchend.scrub', endScrub);
        }

        function endScrub() {
            $(document).off('mousemove.scrub touchmove.scrub');
            $(document).off('mouseup.scrub touchend.scrub');

            if (!was_paused) {
                toggle.addClass('play');
                video.play();
            }
        }

        progress.on('mousedown touchstart', startScrub);

        video.play();
    });
});
